import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import Action from '../action';
import InvoiceApi from '../../Api/inoviceApi';
import {
  setProgressBar,
  setSnackBar,
  closeSnackBar,
  setDialog,
  movePage,
  setMenuType,
  getCode,
  initCheckElement,
  initInvoice,
  initState,
  getInvoice,
  getInvoiceTemp,
  getInvoicePos,
  getInvoiceList,
  getInvoicePosList,
  setInvoiceList,
  getInvoiceListTotalAmout,
  getInvoicePosListTotalAmout,
  getIssueInvoiceDetail,
  objectStorageDownload,
} from './Common';
import taker from './taker';

/**
 * Statistics 초기화
 */
export function* initStatistics() {
  yield put(Action.initStatistics.success());
}

/**
 * [Statistics] sum 팝업 flag
 */
export function* isStatisticsSumPopup({ payload }) {
  yield put(Action.isStatisticsSumPopup.success(payload));
}

/**
 * [Statistics] sum 팝업 flag
 */
export function* isStatisticsPeriodPopup({ payload }) {
  yield put(Action.isStatisticsPeriodPopup.success(payload));
}

/**
 * [Statistics] sum / sum detail 조회
 * @param {*} payload
 */
export function* getStatisticsSum({ payload }) {
  let statisticsSum;
  const responseSum = yield call(InvoiceApi.getStatisticsSum, payload);
  if (responseSum.status === 200) {
    statisticsSum = responseSum.data;
    yield put(Action.getStatisticsSum.success(statisticsSum));
  }
  let statisticsSumDetailList;
  const responseSumDetail = yield call(
    InvoiceApi.getStatisticsSumDetail,
    payload
  );
  if (responseSumDetail.status === 200) {
    statisticsSumDetailList = responseSumDetail.data;
    yield put(Action.getStatisticsSumDetail.success(statisticsSumDetailList));
  }
}

/**
 * [Statistics] sum detail 조회
 * @param {*} payload
 */
export function* getStatisticsSumDetail({ payload }) {
  let statisticsSumDetailList;
  const response = yield call(InvoiceApi.getStatisticsSumDetail, payload);
  if (response.status === 200) {
    statisticsSumDetailList = response.data;
    yield put(Action.getStatisticsSumDetail.success(statisticsSumDetailList));
  }
}

/**
 * [Statistics] sum 팝업 정보
 */
export function* getStatisticsSumPopup({ payload }) {
  let statisticsPopupList;
  const response = yield call(InvoiceApi.getStatisticsSumPopup, payload);
  if (response.status === 200) {
    statisticsPopupList = response.data;
    yield put(Action.getStatisticsSumPopup.success(statisticsPopupList));
    yield put(Action.isStatisticsSumPopup.success(true));
  }
}

/**
 * [Statistics] Period 조회
 * @param {*} payload
 */
export function* getStatisticsPeriod({ payload }) {
  let statisticsPeriodList;
  const response = yield call(InvoiceApi.getStatisticsPeriod, payload);
  if (response.status === 200) {
    statisticsPeriodList = response.data;
    yield put(Action.getStatisticsPeriod.success(statisticsPeriodList));
  }
}

/**
 * [Statistics] Period Detail 조회
 * @param {*} payload
 */
export function* getStatisticsPeriodDetail({ payload }) {
  let statisticsPeriodDetailList;
  const response = yield call(InvoiceApi.getStatisticsPeriodDetail, payload);
  if (response.status === 200) {
    statisticsPeriodDetailList = response.data;
    yield put(
      Action.getStatisticsPeriodDetail.success(statisticsPeriodDetailList)
    );
  }
}

/**
 * [Statistics] Period 팝업 정보
 */
export function* getStatisticsPeriodPopup({ payload }) {
  let statisticsPopupList;
  const response = yield call(InvoiceApi.getStatisticsPeriodPopup, payload);
  if (response.status === 200) {
    statisticsPopupList = response.data;
    yield put(Action.getStatisticsPeriodPopup.success(statisticsPopupList));
    yield put(Action.isStatisticsPeriodPopup.success(true));
  }
}

/**
 * [Statistics] Type 조회
 * @param {*} payload
 */
export function* getStatisticsType({ payload }) {
  let statisticsTypeList;
  const response = yield call(InvoiceApi.getStatisticsType, payload);
  if (response.status === 200) {
    statisticsTypeList = response.data;
    yield put(Action.getStatisticsType.success(statisticsTypeList));
  }
}

/**
 * [StatisticsPosCrm] sum / sum detail 조회
 * @param {*} payload
 */
export function* getStatisticsPosCrmSum({ payload }) {
  let statisticsSum;
  const responseSum = yield call(InvoiceApi.getStatisticsPosCrmSum, payload);
  if (responseSum.status === 200) {
    statisticsSum = responseSum.data;
    yield put(Action.getStatisticsSum.success(statisticsSum));
  }
  let statisticsSumDetailList;
  const responseSumDetail = yield call(
    InvoiceApi.getStatisticsPosCrmSumDetail,
    payload
  );
  if (responseSumDetail.status === 200) {
    statisticsSumDetailList = responseSumDetail.data;
    yield put(Action.getStatisticsSumDetail.success(statisticsSumDetailList));
  }
}

/**
 * [Statistics] sum detail 조회
 * @param {*} payload
 */
export function* getStatisticsPosCrmSumDetail({ payload }) {
  let statisticsSumDetailList;
  const response = yield call(
    InvoiceApi.getStatisticsPosCrmPosCrmSumDetail,
    payload
  );
  if (response.status === 200) {
    statisticsSumDetailList = response.data;
    yield put(Action.getStatisticsSumDetail.success(statisticsSumDetailList));
  }
}

/**
 * [StatisticsPosCrm] sum 팝업 정보
 */
export function* getStatisticsPosCrmSumPopup({ payload }) {
  let statisticsPopupList;
  const response = yield call(InvoiceApi.getStatisticsPosCrmSumPopup, payload);
  if (response.status === 200) {
    statisticsPopupList = response.data;
    yield put(Action.getStatisticsSumPopup.success(statisticsPopupList));
    yield put(Action.isStatisticsSumPopup.success(true));
  }
}

/**
 * [StatisticsPosCrm] Period 조회
 * @param {*} payload
 */
export function* getStatisticsPosCrmPeriod({ payload }) {
  let statisticsPeriodList;
  const response = yield call(InvoiceApi.getStatisticsPosCrmPeriod, payload);
  if (response.status === 200) {
    statisticsPeriodList = response.data;
    yield put(Action.getStatisticsPeriod.success(statisticsPeriodList));
  }
}

/**
 * [StatisticsPosCrm] Period Detail 조회
 * @param {*} payload
 */
export function* getStatisticsPosCrmPeriodDetail({ payload }) {
  let statisticsPeriodDetailList;
  const response = yield call(
    InvoiceApi.getStatisticsPosCrmPeriodDetail,
    payload
  );
  if (response.status === 200) {
    statisticsPeriodDetailList = response.data;
    yield put(
      Action.getStatisticsPeriodDetail.success(statisticsPeriodDetailList)
    );
  }
}

/**
 * [Statistics] PeriodPosCrm 팝업 정보
 */
export function* getStatisticsPosCrmPeriodPopup({ payload }) {
  let statisticsPopupList;
  const response = yield call(
    InvoiceApi.getStatisticsPosCrmPeriodPopup,
    payload
  );
  if (response.status === 200) {
    statisticsPopupList = response.data;
    yield put(Action.getStatisticsPeriodPopup.success(statisticsPopupList));
    yield put(Action.isStatisticsPeriodPopup.success(true));
  }
}

/**
 * [StatisticsPosCrm] Type 조회
 * @param {*} payload
 */
export function* getStatisticsPosCrmType({ payload }) {
  let statisticsTypeList;
  const response = yield call(InvoiceApi.getStatisticsPosCrmType, payload);
  if (response.status === 200) {
    statisticsTypeList = response.data;
    yield put(Action.getStatisticsType.success(statisticsTypeList));
  }
}

export default [
  takeLatest(Action.initStatistics.TRIGGER, taker(initStatistics)),
  takeLatest(Action.getStatisticsSum.TRIGGER, taker(getStatisticsSum)),
  takeLatest(
    Action.getStatisticsSumDetail.TRIGGER,
    taker(getStatisticsSumDetail)
  ),
  takeLatest(
    Action.getStatisticsSumPopup.TRIGGER,
    taker(getStatisticsSumPopup)
  ),

  takeLatest(Action.getStatisticsPeriod.TRIGGER, taker(getStatisticsPeriod)),
  takeLatest(
    Action.getStatisticsPeriodDetail.TRIGGER,
    taker(getStatisticsPeriodDetail)
  ),
  takeLatest(
    Action.getStatisticsPeriodPopup.TRIGGER,
    taker(getStatisticsPeriodPopup)
  ),

  takeLatest(Action.getStatisticsType.TRIGGER, taker(getStatisticsType)),

  takeLatest(Action.isStatisticsSumPopup.TRIGGER, taker(isStatisticsSumPopup)),
  takeLatest(
    Action.isStatisticsPeriodPopup.TRIGGER,
    taker(isStatisticsPeriodPopup)
  ),

  takeLatest(
    Action.getStatisticsPosCrmSum.TRIGGER,
    taker(getStatisticsPosCrmSum)
  ),
  takeLatest(
    Action.getStatisticsPosCrmSumDetail.TRIGGER,
    taker(getStatisticsPosCrmSumDetail)
  ),
  takeLatest(
    Action.getStatisticsPosCrmSumPopup.TRIGGER,
    taker(getStatisticsPosCrmSumPopup)
  ),

  takeLatest(
    Action.getStatisticsPosCrmPeriod.TRIGGER,
    taker(getStatisticsPosCrmPeriod)
  ),
  takeLatest(
    Action.getStatisticsPosCrmPeriodDetail.TRIGGER,
    taker(getStatisticsPosCrmPeriodDetail)
  ),
  takeLatest(
    Action.getStatisticsPosCrmPeriodPopup.TRIGGER,
    taker(getStatisticsPosCrmPeriodPopup)
  ),

  takeLatest(
    Action.getStatisticsPosCrmType.TRIGGER,
    taker(getStatisticsPosCrmType)
  ),
];
